import React from 'react';
import { Zap, Percent, LineChart, Headphones, Gift, TrendingUp } from 'lucide-react';
import { BENEFITS } from '../mock/mock';

const iconMap = { Zap, Percent, LineChart, Headphones, Gift, TrendingUp };

const Benefits = () => {
  return (
    <section id="benefits" className="py-20 lg:py-24 relative overflow-hidden">
      <div className="absolute inset-0 -z-10 mesh-bg opacity-70" />

      <div className="max-w-[1440px] mx-auto px-5 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white border border-purple-200 soft-shadow">
            <span className="text-[11px] font-bold tracking-wider text-[#5F259F] uppercase">Why Choose Us</span>
          </div>
          <h2 className="mt-4 text-4xl lg:text-5xl font-extrabold text-slate-900 leading-tight">
            Benefits that <span className="gradient-text">move your business forward</span>
          </h2>
          <p className="mt-4 text-slate-600">Built for merchants across the Himalayas — fast, secure and delightfully local.</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {BENEFITS.map((b, i) => {
            const Icon = iconMap[b.icon];
            return (
              <div key={b.title} className="group relative bg-white rounded-3xl p-6 border border-purple-100 hover-lift soft-shadow overflow-hidden">
                <div className="absolute -top-10 -right-10 w-32 h-32 rounded-full gradient-soft opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-xl" />
                <div className="relative">
                  <div className="w-14 h-14 rounded-2xl gradient-primary flex items-center justify-center soft-shadow group-hover:rotate-6 transition-transform">
                    <Icon className="w-7 h-7 text-white" />
                  </div>
                  <div className="mt-4 flex items-center gap-2">
                    <span className="text-[11px] font-bold text-[#5F259F]">0{i+1}</span>
                    <span className="h-px flex-1 bg-purple-100" />
                  </div>
                  <h3 className="mt-2 text-xl font-extrabold text-slate-900">{b.title}</h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">{b.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
